export default __webpack_public_path__ + "static/media/compiegne11.ad8e346a.jpg";